import { Entity } from "../../Entity";
import ContactForContractFactory from "../../Factories/ContactForContractFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { ContactForContractInterface } from "./ContactForContractInterface";
import { TypeInterface } from "./Type/TypeInterface";
import { PersonInterface } from "../Person/PersonInterface";

class ContactForContract extends Entity implements ContactForContractInterface {


  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return ContactForContractFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get contactId(): number {
    return this.data.contactId;
  }

  get person(): PersonInterface {
    return this.relation("app.persons", this.data.contactId)[0];
  }

  get description(): string {
    return this.data.description;
  }

  get contactForContractTypeId(): number {
    return this.data.contactForContractTypeId;
  }

  get type(): TypeInterface {
    return this.data.type;
  }

  get removed(): boolean {
    return this.data.removed;
  }
}

export { ContactForContract }
